/* CAFFREY Instant Liquid Polish — page behaviour. Launch build 2026-10-08 (Claude Code, launch agent, WORKFLOW-P builder).
   <cf-ilp-buy>        colour pills -> the main form's hidden [name=id] (+ a bubbling change event, KIT.md §4a), the live
                       price, the chosen-colour label, Add to cart state, the ?variant= URL, the hero of that colour and
                       the bottle tiles' state. Nothing is preselected (LAUNCH-BRIEF bulletin 6, colour treated like size;
                       DECK buy_box): until a colour is chosen, Add to cart, Shop Pay and the kit sticky bar ask for one
                       ("Choose your colour first.", pills highlighted and brought into view, the first one focused).
                       Shop Pay: Shopify greys its button while the form has no id and a disabled button fires no click,
                       so a transparent guard covers it until a colour is chosen (Walk On Air pattern, PRE-PUBLISH-FIXES).
                       The kit sticky bar would print "Unavailable": it is patched to read "Choose your colour".
   Hero               The still loads first, then the selected film plays once automatically while visible.
                       Reduced motion and data saving use the still. Natural uses smooth-leather footage.
   [data-cfilp-pick]  the bottle tiles ("Black. Natural. Brown."): a tap picks that colour in place (the sticky bar then
                       carries Add to cart). Without JS they are plain ?variant= links.
   Safe to load more than once (defer). No dependencies. Never writes the word "undefined" into the page. */
(function () {
  if (window.CfIlpPage) return;
  window.CfIlpPage = true;

  var mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced() { return !!(mq && mq.matches); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function str(v) { return v == null ? '' : String(v); }
  function designMode() { return !!(window.Shopify && window.Shopify.designMode); }

  /* ---------------- hero ---------------- */
  function Hero(root) {
    this.root = root;
    this.stage = root.querySelector('[data-cfilp-stage]');
    this.srcM = root.querySelector('[data-cfilp-still-m]');
    this.still = root.querySelector('[data-cfilp-still]');
    this.video = root.querySelector('[data-cfilp-video]');
    this.desc = root.querySelector('[data-cfilp-film-desc]');
    this.bottle = root.querySelector('[data-cfilp-bottle]');
    this.key = root.getAttribute('data-colour') || 'black';
    this.played = {};
    this.visible = false;
    this.armed = false;
    this.autoplayRefused = false;
    this.pending = false;
    this.requestId = 0;
    var self = this, v = this.video;
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    v.loop = false;
    v.addEventListener('playing', function () {
      if (v.getAttribute('data-key') !== self.key) return;
      v.classList.add('is-playing');
      v.classList.remove('is-done');
    });
    v.addEventListener('ended', function () {
      if (!v.ended) return;
      var key = v.getAttribute('data-key');
      if (key) self.played[key] = true;
      v.classList.add('is-done');
    });
    v.addEventListener('error', function () {
      self.autoplayRefused = true;
      v.classList.remove('is-playing');
    });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) v.pause(); else self.maybePlay();
    });
    if (mq && mq.addEventListener) mq.addEventListener('change', function () {
      if (reduced()) v.pause(); else self.maybePlay();
    });
    if ('IntersectionObserver' in window && this.stage) {
      this.observer = new IntersectionObserver(function (entries) {
        self.visible = entries[entries.length - 1].isIntersecting;
        if (self.visible) self.maybePlay(); else v.pause();
      }, { threshold: 0.01 });
      this.observer.observe(this.stage);
    } else this.visible = true;
    requestAnimationFrame(function () { self.armed = true; self.maybePlay(); });
  }
  Hero.prototype.canFilm = function () {
    if (this.root.getAttribute('data-film') !== 'play' || reduced()) return false;
    var c = navigator.connection;
    return !(c && (c.saveData || /2g$/.test(str(c.effectiveType))));
  };
  Hero.prototype.filmUrl = function (key) { return str(this.root.getAttribute('data-film-' + key)); };
  Hero.prototype.maybePlay = function () {
    if (!this.armed || !this.visible || document.hidden || !this.canFilm() || this.autoplayRefused || this.played[this.key]) return;
    this.play();
  };
  Hero.prototype.play = function () {
    var v = this.video, key = this.key, url = this.filmUrl(key), self = this;
    if (!v || !url || this.pending || (!v.paused && !v.ended)) return;
    if (v.getAttribute('data-key') !== key || v.error) {
      v.classList.remove('is-playing', 'is-done');
      v.setAttribute('data-key', key);
      v.src = url;
      v.load();
    }
    this.pending = true;
    var request = ++this.requestId;
    var success = function () {
      if (request !== self.requestId) return;
      self.pending = false;
    };
    var fail = function (error) {
      if (request !== self.requestId) return;
      self.pending = false;
      if (error.name !== 'AbortError') self.autoplayRefused = true;
    };
    try {
      var p = v.play();
      if (p && p.then) p.then(success, fail); else success();
    } catch (error) { fail(error); }
  };
  Hero.prototype.set = function (key, r, restart) {
    if (!r) return;
    if (key !== this.key || restart) {
      this.requestId++;
      this.pending = false;
      this.autoplayRefused = false;
      this.played[key] = false;
      this.key = key;
      this.root.setAttribute('data-colour', key);
      if (key !== 'neutral' || this.root.hasAttribute('data-natural-film')) {
        var m = r.getAttribute('data-m'), d = r.getAttribute('data-d'), dsrc = r.getAttribute('data-dsrc');
        if (this.srcM && m) {
          this.srcM.setAttribute('srcset', m);
          this.srcM.setAttribute('width', str(r.getAttribute('data-mw')));
          this.srcM.setAttribute('height', str(r.getAttribute('data-mh')));
        }
        if (this.still) {
          if (this.still.getAttribute('loading') === 'lazy') this.still.setAttribute('loading', 'eager');
          if (d) this.still.setAttribute('srcset', d);
          if (dsrc) this.still.setAttribute('src', dsrc);
          this.still.setAttribute('width', str(r.getAttribute('data-dw')));
          this.still.setAttribute('height', str(r.getAttribute('data-dh')));
          var alt = r.getAttribute('data-alt');
          if (alt) this.still.alt = alt;
        }
        if (this.desc) this.desc.textContent = str(r.getAttribute('data-desc'));
      }
      if (this.video) {
        var v = this.video;
        if (!v.paused) v.pause();
        v.classList.remove('is-playing', 'is-done');
        v.removeAttribute('data-key');
        v.removeAttribute('src');
        try { v.load(); } catch (e) { /* ignore */ }
      }
    }
    this.swapBottle(r);
    this.maybePlay();
  };
  Hero.prototype.swapBottle = function (r) {
    var img = this.bottle;
    if (!img) return;
    var b = r.getAttribute('data-b'), src = r.getAttribute('data-bsrc'), alt = r.getAttribute('data-balt');
    if (!b || img.getAttribute('srcset') === b) return;
    var apply = function () {
      img.setAttribute('srcset', b);
      if (src) img.setAttribute('src', src);
      if (alt) img.alt = alt;
    };
    if (reduced() || typeof img.animate !== 'function') { apply(); return; }
    var out = img.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 120, easing: 'ease-in', fill: 'forwards' });
    var back = function () { img.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 200, easing: 'ease-out', fill: 'forwards' }); };
    (out.finished || Promise.resolve()).then(function () {
      apply();
      if (img.decode) img.decode().then(back, back); else back();
    }).catch(function () { apply(); back(); });
  };

  /* ---------------- buy box ---------------- */
  class IlpBuy extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      var heroRoot = this.closest('[data-cfilp-hero]');
      this.hero = heroRoot ? new Hero(heroRoot) : null;
      this.form = document.getElementById(this.dataset.form);
      if (!this.form) return;
      this.idInput = this.form.querySelector('input[type="hidden"][name="id"]');
      if (this.idInput) this.idInput.disabled = false; /* disabled in the HTML so no-JS shoppers use the <noscript> select */
      this.atc = this.form.querySelector('[data-cf-atc]');
      this.atcLabel = this.atc ? this.atc.querySelector('span') : null;
      this.msg = this.querySelector('[data-cfilp-ask]');
      this.box = this.querySelector('[data-cfilp-colours]');
      this.chosenEl = this.querySelector('[data-cfilp-chosen]');
      this.guard = this.querySelector('[data-cfilp-pay-guard]');
      this.radios = Array.prototype.slice.call(this.querySelectorAll('input[type="radio"]'));
      if (!this.radios.length) return; /* single-variant product: the kit form works as it is */

      this.addEventListener('change', function (e) {
        if (e.target && self.radios.indexOf(e.target) > -1) self.select(e.target, true);
      });
      this.addEventListener('click', function (e) {
        if (e.target && self.radios.indexOf(e.target) > -1 && self._selectedRadio === e.target) self.select(e.target, true);
      });
      this.addEventListener('keydown', function (e) {
        if ((e.key === ' ' || e.code === 'Space') && self.radios.indexOf(e.target) > -1) {
          e.preventDefault();
          if (e.repeat) return;
          e.target.checked = true;
          self.select(e.target, true);
        }
      });
      /* capture phase on an ancestor of the form: runs before Dawn's <product-form> submit handler */
      this.addEventListener('submit', function (e) {
        if (e.target !== self.form || self.current()) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        self.ask();
      }, true);
      if (this.guard) this.guard.addEventListener('click', function (e) { e.preventDefault(); self.ask(); });
      /* keyboard users can still reach Shopify's "More payment options" under the guard: with no colour chosen,
         a click anywhere in the payment block asks for a colour instead */
      var pay = this.querySelector('[data-cfilp-pay]');
      if (pay) pay.addEventListener('click', function (e) {
        if (self.current() || (e.target.closest && e.target.closest('[data-cfilp-pay-guard]'))) return;
        e.preventDefault();
        e.stopPropagation();
        self.ask();
      }, true);
      /* the bottle tiles further down the page pick in place */
      document.addEventListener('click', function (e) {
        var a = e.target && e.target.closest ? e.target.closest('[data-cfilp-pick]') : null;
        if (!a) return;
        var r = self.radioFor(a.getAttribute('data-cfilp-pick'));
        if (!r || r.getAttribute('data-available') !== 'true') return;
        e.preventDefault();
        r.checked = true;
        self.select(r, true);
      });
      window.addEventListener('pageshow', function () { self.sync(); });
      this.sync();
      this.watchSticky();
    }
    current() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].checked) return this.radios[i];
      return null;
    }
    firstAvailable() {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].getAttribute('data-available') === 'true') return this.radios[i];
      return null;
    }
    radioFor(id) {
      for (var i = 0; i < this.radios.length; i++) if (this.radios[i].value === str(id)) return this.radios[i];
      return null;
    }
    sync() {
      var r = this.current();
      if (r) this.select(r, false); else this.none();
    }
    setId(value) {
      if (this.idInput && this.idInput.value !== value) {
        this.idInput.value = value;
        this.idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    none() {
      this._selectedRadio = null;
      var any = !!this.firstAvailable();
      this.setId('');
      if (this.chosenEl) this.chosenEl.textContent = '';
      if (this.atc) {
        this.atc.disabled = !any;
        if (this.atcLabel) this.atcLabel.textContent = any ? str(this.dataset.add) : str(this.dataset.soldOut);
      }
      if (this.guard) this.guard.hidden = !any;
      this.tiles(null);
      this.patchSticky();
    }
    select(r, byUser) {
      this._selectedRadio = r;
      var available = r.getAttribute('data-available') === 'true';
      this.setId(r.value);
      var price = r.getAttribute('data-price');
      if (price) each(document.querySelectorAll('[data-cfilp-price]'), function (el) { if (el.textContent !== price) el.textContent = price; });
      if (this.chosenEl) this.chosenEl.textContent = str(r.getAttribute('data-title'));
      if (this.atc) {
        this.atc.disabled = !available;
        if (this.atcLabel) this.atcLabel.textContent = available ? str(this.dataset.add) : str(this.dataset.soldOut);
      }
      if (this.guard) this.guard.hidden = true;
      this.clearAsk();
      if (this.hero) this.hero.set(r.getAttribute('data-key') || 'black', r, byUser);
      this.tiles(r.value);
      this.patchSticky();
      if (byUser && !designMode() && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', r.value);
          history.replaceState(history.state, '', u.toString());
        } catch (e) { /* ignore */ }
      }
    }
    tiles(id) {
      each(document.querySelectorAll('[data-cfilp-pick]'), function (a) {
        if (id && a.getAttribute('data-cfilp-pick') === id) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    /* "Choose your colour first.": message under the pills, pills highlighted, brought into view, first one focused */
    ask() {
      var first = this.firstAvailable();
      var st = document.querySelector('cf-kit-sticky');
      if (st && typeof st.done === 'function') st.done();
      if (!first) return;
      if (this.msg) {
        this.msg.textContent = str(this.dataset.ask);
        this.msg.hidden = false;
      }
      if (this.box) {
        this.box.classList.remove('is-asking');
        void this.box.offsetWidth; /* restart the highlight when asked again */
        this.box.classList.add('is-asking');
        var b = this.box.getBoundingClientRect();
        if (b.top < 72 || b.bottom > window.innerHeight - 96) {
          this.box.scrollIntoView({ block: 'center', behavior: reduced() ? 'auto' : 'smooth' });
        }
      }
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
    clearAsk() {
      if (this.msg && !this.msg.hidden) { this.msg.hidden = true; this.msg.textContent = ''; }
      if (this.box) this.box.classList.remove('is-asking');
    }
    /* the kit sticky bar (cf-kit-sticky, shared) mirrors the form's id: with none it reads "Unavailable" */
    watchSticky() {
      var self = this;
      var tries = 0;
      var attach = function () {
        var st = document.querySelector('cf-kit-sticky');
        if (!st) { if (++tries < 40) setTimeout(attach, 250); return; }
        if (self._stObs) return;
        self._st = st;
        self._stObs = new MutationObserver(function () { self.patchSticky(); });
        self._stObs.observe(st, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
        self.patchSticky();
      };
      attach();
    }
    patchSticky() {
      var st = this._st;
      if (!st) return;
      var btn = st.querySelector('[data-cf-sticky-atc]');
      var label = btn ? btn.querySelector('span') : null;
      var v = st.querySelector('[data-cf-sticky-variant]');
      var r = this.current();
      if (r) {
        var want = str(r.getAttribute('data-title'));
        if (v && v.textContent !== want) v.textContent = want;
        return; /* availability and price: the kit's own sync */
      }
      if (!this.firstAvailable()) return; /* nothing in stock: keep the kit's sold-out state */
      var add = str(this.dataset.add), choose = str(this.dataset.choose);
      if (btn && btn.disabled) btn.disabled = false;
      if (label && add && label.textContent !== add) label.textContent = add;
      if (v && choose && v.textContent !== choose) v.textContent = choose;
    }
  }

  if (!customElements.get('cf-ilp-buy')) customElements.define('cf-ilp-buy', IlpBuy);
})();
